
    import i18n from "i18next";
    import { initReactI18next } from "react-i18next";
    
      import Backend from "i18next-http-backend";
      import LanguageDetector from "i18next-browser-languagedetector";
    

    i18n
      .use(Backend)
      .use(initReactI18next)
      
      .use(LanguageDetector)
      .init({
        fallbackLng: "en-us",
        supportedLngs: ["en-us","fr-fr","de-de","zh-cn","it-it","ja-jp","ko-kr","pt-br","es-419","sw-ke","tr-tr","zu"],
        lowerCaseLng: true,
        defaultNS: "common",
        ns: ["common"],
        interpolation: { escapeValue: false },
        backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
        
      detection: {
        caches: [],
        order: ["htmlTag"],
      },
    
      });
 
  